<template>
	<div >
		<div class="order_tabs">
			<template v-for="(itme,i) in tabs" >
				<div :key="i" class="tab " :class="{'tab_cho':index==i}" @click="addASD(i)">{{itme}}</div>
				<span :key="'F'+i" v-if="tabs.length-1 != i">|</span>
			</template>
		</div>
		<div v-loading="loading" class="min_he400">
			<div class="order_zi" v-for="item in invoiceList" :key="item.id">
				<div class="zi_to">
					<span>{{item.create_time*1000 | timeFormat}}</span>
					<span>订单号:{{item.orders_id}}</span>
				</div>
				<div class="zi_box">
					<div class="zi_download">
						<div>发票信息：{{item.type==1?'专票':'普票'}}</div>
						<div>发票抬头：{{item.look}}</div>
						<div>纳税人识别号：{{item.identify_number}}</div>
						<div>发票号：{{item.number}}</div>
						<div>发票日期：{{item.update_time*1000 | timeFormat}}</div>
					</div>
					<div class="zi_btn">
						<div class="lan">{{item.status | invo}}</div>
						<!-- <div v-if="item.status==0" class="lan">请开票</div> -->
					</div>
				</div>
			</div>
			<div class="order_zi" v-if="invoiceList.length==0">
				<div class="kunasg">
					您还没有发票呢~~
				</div>
			</div>
			<div class="bottom_paging">
				<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
				:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				loading:true,
				total:0,//总数量
				pageNo:1,//当前页
				limit:0,//一页多少条
				index:0,
				tabs:['所有发票','待开票','已开票','已取消'],
				invoiceList:[],
			}
		},
		created(){
			this.PostuserInvoice();
		},
		methods:{
			addASD(i){
				this.index = i;
				this.pageNo=1;
				this.PostuserInvoice()
			},
			pageCurrentChange(val) {//分页查询
				this.pageNo = val;
				this.PostuserInvoice();
			},
			async PostuserInvoice(){
				this.loading = true;
				let status = this.index==0?null:this.index-1;
				let {data} = await this.api.PostuserInvoice({status,page:this.pageNo});
				this.invoiceList = data.data||[];
				this.total = data.total;
				this.limit = data.per_page;
				this.loading = false;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.order_zi{
		margin-top: 20px;
		.zi_box{
			box-sizing: border-box;
			height: 200px;
			border: 1px solid #f2f2f2;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 20px 0;
			color: #333333;
			.zi_download{
				height: 100%;
				margin-left: 40px;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
			}
			.zi_btn{
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin-right: 50px;
			}
		}
		.zi_to{
			line-height: 40px;
			// padding-left: 40px;
			height: 40px;
			color: #666;
			// border: 1px dashed #666;
			background: #F2F2F2;
			span{
				margin-left: 40px;
			}
		}
	}
</style>
